import { MenuBook } from "@mui/icons-material";
import color from "../../constants/color";
const styles = {
  pageWrap: {
    p: "20px",
    boxSizing: "border-box",
  },
  sectionGrid: {
    width: "100%",
    alignItems: "stretch",
  },
  equalGridItem: {
    display: "flex",
    flexDirection: "column",
  },
  columnCell: {
    p: "20px",
    boxSizing: "border-box",
  },
  equalGridContainer: {
    height: "100%",
  },
  heading:{
    fontSize:"18px",
    fontWeight:"600",
    mt: 2,
    lineHeight: "21px"
  },
  inputGrid: {
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    mt: 1.5,
    mb: 1.5,

  },
  submitButton: {
    borderRadius: 50,
    mt: 0.5,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.primary,
    minHeight: "38px",
    minWidth: "130px",
    px: 3,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
    "&:hover": {
      backgroundColor: color.primary,
    },
  },
  transferButtonFit: {
    minWidth: "unset",
    width: "fit-content",
    px: 2,
  },
  cancelBtn: {
    
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#878787",
    ml: 1,
      
  },
  inputText: {
    fontSize: "12px",
    // fontWeight: "500",
    // color: "#202020",
  },

  successBtn: {
    
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    minHeight: "38px",
    minWidth: "130px",
    px: 3,
    fontSize: "14px",
    fontWeight: "500",
  },
  formPhone: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      marginTop: "0.5em",
      borderRadius: "10px",
      width: "100%",
    },
    ".react-tel-input": {
      width: "100%",
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        }
      },
      ".form-control": {
        borderRadius: "10px",
        mt: "7px",
        // height: "2.5em", // Match height with MUI input
        width: "100%",

      },
    },

  },

  formGrid: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      marginTop: "0.5em",
      borderRadius: "10px",
    },

  },
  greenLine: {
    backgroundColor: "#28AA4A",
    width: "12px",
    height: 2,
    borderRadius: "4px",
    mb:2
  },
  subHeading:{
    fontSize:"14px",
    fontWeight:"500",
    ml: 2,
    lineHeight: "21px",
    mb:2
  },
  formControl:{
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      my: "0.5em",
      borderRadius: "10px",
    },
  },
  changeText:{
    fontSize:"12px",
    fontWeight:"400",
    color:color.text,
    width:{xs:"50%", md: "20%"},
    ml:1
  },
  dropdown:{
    borderRadius: "10px",
    my: 1,
    height:"2.5em",},
  card:{ 
    backgroundColor: "#fff", 
    borderRadius: "20px",
    pr:2,
    py: 2,
    mb: 1,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.04)",
    "& .css-a5rdam-MuiGrid-root":{
      marginTop:"11px",
    }
  },
  sectionCard: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    pr: 2,
    py: 2,
    mb: 1,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.04)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: { xs: "auto", md: "255px" },
    height: "100%",
    "& .css-a5rdam-MuiGrid-root": {
      marginTop: "11px",
    },
  },
  dropDownMenu:{
    fontSize:"14px",
    fontWeight:"400"
  },
  formControlLabel:{
    m:0,
    " & .css-1ismtrt-MuiTypography-root":{
      fontSize: "14px",
      width: "100%"
    }
  },
  line:{ backgroundColor: "#28AA4A", 
    width: "2%", 
    height: 2 },

  boxGrid: {
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    ml:"2%",
    my:"2%"
  },
  pensionGrid: {
    display: "flex",
    alignItems: "center",
    mt:2
  },
  pensionHeading: {
    fontSize: "18px",
    fontWeight: "600",
    color: color.text,
    mt:2
  },
  addBtn: {
    fontSize: "12px",
    borderRadius: 50,
    textTransform: "none",
    color: color.card,
    backgroundColor: color.primary,
    // fontWeight: "500",
    px: 4,
    ml:4,
    "&:hover": {
      color: color.card,
      backgroundColor: color.primary,
  
    }

  },
  labels:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text, 
    mb:1
  },
  dropdowns:{
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p:0,
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      p:1
    }
  },
  mainGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "top",
    mt: 1,
    mb: 0.5,
  },
  formActionRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    pb: 3,
  },
  planInfoCard: {
    backgroundColor: color.lightGray,
    borderRadius: "12px",
    px: 1.5,
    py: 1.25,
    minHeight: "72px",
  },
  planInfoLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: color.lightText,
    mb: 0,
  },
  planInfoValue: {
    fontSize: "14px",
    fontWeight: 600,
    color: color.text,
    wordBreak: "break-word",
    textAlign: "right",
  },
  planInfoRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 2,
    py: 0.75,
    borderBottom: "1px solid #F1F1F1",
    "&:last-of-type": {
      borderBottom: "none",
    },
  },
  mncStandardCard: {
    mt: 2,
    p: 1.5,
    borderRadius: "12px",
    backgroundColor: "#EAF7EE",
    border: "1px solid #D4EEDB",
  },
  mncHeading: {
    fontSize: "13px",
    fontWeight: 600,
    color: color.primary,
    mb: 0.5,
  },
  mncText: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: color.text,
    textAlign: "left",
    wordBreak: "break-all",
  },
  transactionsWrap: {
    mt: 1.5,
    mb: 1,
    p: 1.25,
    border: "1px solid #E9E9E9",
    borderRadius: "10px",
    backgroundColor: "#FAFAFA",
  },
  transactionsHeading: {
    fontSize: "13px",
    fontWeight: 600,
    color: color.text,
    mb: 0,
  },
  transactionsHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    mb: 1,
  },
  transactionsToggleBtn: {
    minWidth: "unset",
    textTransform: "none",
    fontSize: "12px",
    color: color.primary,
    p: 0,
  },
  transactionRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: 1,
    py: 0.6,
    borderBottom: "1px solid #ECECEC",
    "&:last-of-type": {
      borderBottom: "none",
    },
  },
  transactionText: {
    fontSize: "12px",
    fontWeight: 500,
    color: color.text,
  },
  transactionMeta: {
    fontSize: "12px",
    color: color.lightText,
  },
  transactionTableWrap: {
    border: "1px solid #ECECEC",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#fff",
  },
  transactionHeadCell: {
    fontSize: "12px",
    fontWeight: 600,
    color: color.lightText,
    backgroundColor: "#F8F8F8",
    py: 1,
  },
  transactionBodyCell: {
    fontSize: "12px",
    color: color.text,
    py: 0.9,
    borderBottom: "1px solid #F2F2F2",
  },
  inviteActions: {
    mt: 1,
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  inviteBtn: {
    textTransform: "none",
    borderRadius: "20px",
  },
  invitePrimaryBtn: {
    textTransform: "none",
    borderRadius: "20px",
    backgroundColor: color.primary,
    "&:hover": {
      backgroundColor: color.primary,
    },
  },
  planActionsRow: {
    mt: "auto",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    ml: 0.5,
  },
  downgradePlanBtn: {
    borderRadius: "30px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
    px: 3,
    borderColor: color.primary,
    color: color.primary,
    "&:hover": {
      borderColor: color.primary,
      backgroundColor: "transparent",
    },
  },
  upgradePlanBtn: {
    borderRadius: "30px",
    textTransform: "none",
    backgroundColor: color.primary,
    fontSize: "14px",
    fontWeight: 500,
    px: 3,
    "&:hover": {
      backgroundColor: color.primary,
    },
  },
  uniformInputHeight: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      borderRadius: "10px",
    },
    "& .MuiInputBase-input": {
      py: "10px",
    },
  },
  additionalButtons: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: color.secondary, 
    fontSize: "12px",
    fontWeight: "500",
    px: 4,
    boxShadow: "none",
  },
  dropdownRight:{
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p:0,
    ml:1,

    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      p:1
    }
  },



  pensionText: {
    width: "40%"
  },
  medicalTxt: {
    fontSize: "14px",
  },
  subTitle:{
    fontWeight: "500",
    fontSize:"14px",
    color:color.text,
    ml:2
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    display: "flex",
    justifyContent: "center",
    my: "0.5em",


  },
  deleteIcon: {
    p: 1,
    // pb: 0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    my: "0.5em",



  },


};

export default styles;
